import { HeroWithBackgroundStrapi } from '@/decodo/blocks/BackgroundImageHero/BackgroundImageHeroStrapi';
import { CareersHeroStrapi } from '@/decodo/blocks/CareersHero/CareersHeroStrapi';
import { CodeBlockStrapi } from '@/decodo/blocks/CodeBlock/CodeBlockStrapi';
import { CTABlockStrapi } from '@/decodo/blocks/CTABlock/CTABlockStrapi';
import FAQStrapi from '@/decodo/blocks/FAQ/FAQStrapi';
import { FeaturesBlockStrapi } from '@/decodo/blocks/FeaturesBlock/FeaturesBlockStrapi';
import FooterBannerStrapi from '@/decodo/blocks/FooterBanner/FooterBannerStrapi';
import { HeroStrapi } from '@/decodo/blocks/Hero/HeroStrapi';
import { HeroWithSearchStrapi } from '@/decodo/blocks/HeroWithSearch/HeroWithSearchStrapi';
import ImageAccordionsStrapi from '@/decodo/blocks/ImageAccordions/ImageAccordionsStrapi';
import { ImageBlockStrapi } from '@/decodo/blocks/imageBlock/ImageBlockStrapi';
import { ImageTextStrapi } from '@/decodo/blocks/ImageText/ImageTextStrapi';
import { JobApplicationFormStrapi } from '@/decodo/blocks/JobApplicationForm/JobApplicationFormStrapi';
import { LogoCarouselStrapi } from '@/decodo/blocks/LogoCarousel/LogoCarouselStrapi';
import { OpenPositionsStrapi } from '@/decodo/blocks/OpenPositions/OpenPositionsStrapi';
import { PricingCardsStrapi } from '@/decodo/blocks/PricingCards/PricingCardsStrapi';
import { PricingTableStrapi } from '@/decodo/blocks/pricingTable/PricingTableStrapi';
import { ProductComparisonTableStrapi } from '@/decodo/blocks/ProductComparisonTable/ProductComparisonTableStrapi';
import { RecommendationCardsStrapi } from '@/decodo/blocks/RecommendationCards/RecommendationCardsStrapi';
import { ScraperStrapi } from '@/decodo/blocks/Scraper/ScraperStrapi';
import ScrapingTemplateLibraryStrapi from '@/decodo/blocks/ScrapingTemplateLibrary/ScrapingTemplateLibraryStrapi';
import ScrapingTemplatesPreviewStrapi from '@/decodo/blocks/ScrapingTemplatesPreview/ScrapingTemplatesPreviewStrapi';
import SimpleCardsStrapi from '@/decodo/blocks/SimpleCards/SimpleCardsStrapi';
import { SocialProofStrapi } from '@/decodo/blocks/SocialProof/SocialProofStrapi';
import { TableStrapi } from '@/decodo/blocks/Table/TableStrapi';
import { TextBlockStrapi } from '@/decodo/blocks/TextBlock/TextBlockStrapi';
import { VideoBlockStrapi } from '@/decodo/blocks/VideoBlock/VideoBlockStrapi';
import { WhatIsMyIpHeroStrapi } from '@/decodo/blocks/WhatIsMyIpHero/WhatIsMyIpHeroStrapi';
import { BannerStrapi } from '@/decodo/components/atoms/banner/BannerStrapi';
import { SideBannerStrapi } from '@/decodo/components/atoms/banner/SideBannerStrapi';
import { BreadcrumbsStrapi } from '@/decodo/components/atoms/Breadcrumbs/BreadcrumbsStrapi';
import { ImageLinkStrapi } from '@/decodo/components/atoms/imageLink/ImageLinkStrapi';
import { QuoteStrapi } from '@/decodo/components/atoms/Quote/QuoteStrapi';
import AccordionListStrapi from '@/decodo/components/molecules/accordion/AccordionListStrapi';
import { ArticlesFeedStrapi } from '@/decodo/components/organisms/articles-feed/ArticlesFeedStrapi';
import { AuthorStrapi } from '@/decodo/components/organisms/author/AuthorStrapi';
import { CarouselBlockStrapi } from '@/decodo/components/organisms/CarouselBlock/CarouselBlockStrapi';
import GatedContentBlockStrapi from '@/decodo/components/organisms/GatedContent/GatedContentBlockStrapi';
import { RelatedArticlesStrapi } from '@/decodo/components/organisms/relatedArticles/RelatedArticlesStrapi';
import SocialWidgetItem from '@/decodo/components/organisms/SocialWidget/SocialWidgetItem';
import { TextGridStrapi } from '@/decodo/components/textGrid/TextGridStrapi';
import CardsWithHeaderStrapi from '@/decodo/features/cards/CardsWithHeader/CardsWithHeaderStrapi';
import ProductCardsStrapi from '@/decodo/features/cards/ProductCards/ProductCardsStrapi';
import { HomepageHeroStrapi } from '@/decodo/features/HomepageHero/HomepageHeroStrapi';
import { PopupBannerStrapiDC } from '@/decodo/features/PopupBanner/PopupBannerStrapi';
import { BlogOverviewStrapi } from '@/decodo/features/shared/BlogOverview/BlogOverviewStrapi';

export const DecodoComponentsMap: { [key: string]: React.ElementType } = {
  // molecules
  'molecules.breadcrumbs': BreadcrumbsStrapi,
  'molecules.accordion-list': AccordionListStrapi,
  'molecules.image-link': ImageLinkStrapi,
  'molecules.quote-component': QuoteStrapi,
  'molecules.image-block': ImageBlockStrapi,
  // TODO: fix? errors out in demo page
  'molecules.banner': BannerStrapi,

  // organisms
  'organisms.table': TableStrapi,
  'organisms.code-block': CodeBlockStrapi,
  'organisms.text-grid': TextGridStrapi,
  'organisms.open-positions-list': OpenPositionsStrapi,
  'organisms.social-widget': SocialWidgetItem,
  'organisms.scraping-template-library': ScrapingTemplateLibraryStrapi,
  'organisms.scraping-template-preview': ScrapingTemplatesPreviewStrapi,
  // integrations
  // TODO: remove integrations from list once rebranded
  'integration.g2-badge': () => null,
  'integration.proxyway-badge': () => null,
  'integration.trustpilot-badge': () => null,
  // faq
  'accordions.faq': FAQStrapi,
  // layout
  'layout.footer-banner': FooterBannerStrapi,
  // cards
  'cards.cards-with-header': CardsWithHeaderStrapi,
  'cards.pricing-cards': PricingCardsStrapi,
  'cards.simple-cards': SimpleCardsStrapi,
  'cards.recommendation-cards': RecommendationCardsStrapi,
  'cards.social-proof': SocialProofStrapi,
  'cards.product-cards': ProductCardsStrapi,
  'cards.pricing-table': PricingTableStrapi,
  // text-media
  'text-media.image-accordions': ImageAccordionsStrapi,
  'shared.image-text': ImageTextStrapi,
  'hero.hero': HeroStrapi,
  'hero.background-image-hero': HeroWithBackgroundStrapi,
  'hero.homepage-hero': HomepageHeroStrapi,
  'hero.what-is-my-ip-hero': WhatIsMyIpHeroStrapi,
  'hero.hero-with-search': HeroWithSearchStrapi,
  'hero.careers-hero': CareersHeroStrapi,
  // blog
  // TODO: SideBannerStrapi goes here, but button prop and buttons (repeateable) in Strapi don't match.
  // once fixed, pls add here
  'blog.blog-side-banner': SideBannerStrapi,

  'blog.author': AuthorStrapi,
  'blog.related-articles': RelatedArticlesStrapi,
  'blog.articles-feed': ArticlesFeedStrapi,
  // shared
  'shared.text-block': TextBlockStrapi,
  'shared.video-block': VideoBlockStrapi,
  'shared.cta-block': CTABlockStrapi,
  'shared.blog-overview': BlogOverviewStrapi,
  'shared.scraper': ScraperStrapi,
  'shared.popup-banner': PopupBannerStrapiDC,
  'shared.job-application-form': JobApplicationFormStrapi,
  'shared.gated-content': GatedContentBlockStrapi,
  'shared.product-comparison-table': ProductComparisonTableStrapi,
  // carousels
  'carousels.carousel-block': CarouselBlockStrapi,
  'carousels.top-banner': () => null,
  'carousels.hero-carousel': () => null,
  'carousels.images-carousel': LogoCarouselStrapi,
  'shared.features-block': FeaturesBlockStrapi,
};
